module.exports = __webpack_public_path__ + "static/media/textAnimation2.68cec2c8.gif";